import If from '@mobi/components/If'
import Text from 'components/Text'
import CountdownTimer from 'components/CountdownTimer'

const CountDownLP = ({ data, targetDate }) => {
  return (
    <div className="lp-countdown">
      <If
        condition={data.title}
        renderIf={
          <Text p className="lp-countdown__text">
            <span className="lp-countdown__text--bold">{data.boldText}</span>{' '}
            {data.title}
          </Text>
        }
      />
      <CountdownTimer targetDate={targetDate} separator=":" />
    </div>
  )
}

export default CountDownLP
